module.exports = __webpack_public_path__ + "img/huxing3.9987aacd.jpg";